// work-description v1: 作品描述组件

/**
 * 作品描述组件
 * @param {Object} workData - 作品数据
 * @param {string} className - 额外的CSS类名
 */
const WorkDescription = ({ workData, className = '' }) => {
  return (
    <div
      className={`bg-transparent p-6 mb-28 border-l border-white ${className}`}
    >
      <h2 className='text-xl font-bold text-white mb-2'>{workData.title}</h2>
      <p className='text-gray-300 mb-4'>{workData.description}</p>
      <div className='space-y-2 text-sm'>
        <div className='flex justify-between'>
          <span className='text-gray-400'>Date:</span>
          <span className='text-white'>{workData.date}</span>
        </div>
      </div>
    </div>
  );
};

export default WorkDescription;
